export type TbclLevelKey = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const TBCL_LEVELS = [1, 2, 3, 4, 5, 6, 7] as const satisfies readonly TbclLevelKey[];

export function isTbclLevelKey(value: number): value is TbclLevelKey {
  return (TBCL_LEVELS as readonly number[]).includes(value);
}
